import React from "react";
import errorLogo from "../assets/images/logo.ico";
import "../styles/error.css";
const ErrorScreen = ({ message }) => {
  return (
    <div className="error-screen">
      <img src={errorLogo} alt="Error" className="error-logo" />
      <h2>서버 연결에 문제가 발생했어요 😢</h2>
      <p>{message || "잠시 후 다시 시도해주세요."}</p>
    </div>
  );
};

export default ErrorScreen;